import { site } from "../config/site";

const CONSENT_KEY = "gobax_consent";
let scriptsLoaded = false;

if (typeof window !== "undefined") {
  window.dataLayer = window.dataLayer || [];
}

export const getConsent = () => {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
};

export const setConsent = (value) => {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {}
  if (value === "granted") loadAnalytics();
};

export const trackEvent = (event, params = {}) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
  if (window.fbq) window.fbq("trackCustom", event, params);
};

export function initAnalytics() {
  if (getConsent() === "granted") loadAnalytics();
}

function loadAnalytics() {
  if (scriptsLoaded || typeof document === "undefined") return;
  scriptsLoaded = true;
  const { gtmId, ga4Id, metaPixelId, googleAdsId } = site.tracking;

  if (gtmId) {
    window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`;
    document.head.appendChild(s);
  }

  const gtagIds = [ga4Id, googleAdsId].filter(Boolean);
  if (gtagIds.length) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(gtagIds[0])}`;
    document.head.appendChild(s);
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    gtagIds.forEach((id) => window.gtag("config", id, { anonymize_ip: true }));
  }

  if (metaPixelId) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", metaPixelId);
    window.fbq("track", "PageView");
  }
}
